import React, { useCallback } from "react";
import classNames from "classnames";
import { AccountantCallRoute, getAccountantCallUrl } from "@common/billing";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { useWidgetOptions } from "@design-system/BookCall/useWidgetOptions";
import { useUpdateUserMutation } from "@api/user.api";
import { useUser } from "@hooks/useUser";
import { Footer } from "@components/onboarding/components/Footer";
import { FlowContext } from "@components/onboarding/flowContext";
import animations from "@components/onboarding/layout/OnboardingLayout.module.scss";
import commonStyles from "../../steps/common.module.scss";

interface Props {
    onContinue(contextOverride?: Partial<FlowContext>): void;
    back(): void;
    route: AccountantCallRoute;
}

export const AccountantPartnerCall: React.FC<Props> = ({
    onContinue,
    back,
    route,
}) => {
    const user = useUser();
    const updateUser = useUpdateUserMutation();

    const handleEnterpriseCallBooked = useCallback(async () => {
        await updateUser.mutateAsync({ bookedEnterpriseCall: true });
        const updatedContext: Partial<FlowContext> = {
            user: {
                preferredName: user.preferredName ?? "",
                signupPurpose: user.signupPurpose!,
                bookedEnterpriseCall: true,
            },
        };
        onContinue(updatedContext);
    }, [onContinue, updateUser, user]);

    const { prefill, pageSettings } = useWidgetOptions({});

    useCalendlyEventListener({
        onEventScheduled: handleEnterpriseCallBooked,
    });

    return (
        <div
            className={classNames(animations.fadeIn1, commonStyles.content1100)}
        >
            <header className={animations.fadeIn2}>
                <h1
                    className={classNames(
                        commonStyles.iconSpacer,
                        commonStyles.title,
                    )}
                >
                    You're a fit for Kick's AI-Native program
                </h1>

                <p
                    className={classNames(
                        "mb-0",
                        commonStyles.iconSpacer,
                        commonStyles.subtitle,
                    )}
                >
                    Schedule a demo to learn more
                </p>
            </header>

            <InlineWidget
                url={getAccountantCallUrl(route)}
                pageSettings={pageSettings}
                prefill={prefill}
            />

            <Footer onBack={back} />
        </div>
    );
};
